import type { SVGProps } from 'react';

type ShareIconProps = Omit<
  SVGProps<SVGSVGElement>,
  'width' | 'height' | 'color' | 'strokeWidth'
> & {
  size?: number | string;
  color?: string;
  /** Tray stroke weight. The arrow is a solid fill. */
  strokeWidth?: number;
};

/** Web twin of the canonical original arrow-from-tray share glyph. */
export function ShareIcon({
  size = 20,
  color = 'currentColor',
  strokeWidth = 1.5,
  ...props
}: ShareIconProps) {
  return (
    <svg
      {...props}
      width={typeof size === 'number' ? (size * 16) / 19 : size}
      height={size}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.09012 2.00135L4.49614 4.57042C4.29631 4.76374 3.87641 4.82125 3.67532 4.62915C3.57879 4.52536 3.52539 4.39069 3.52539 4.25108C3.52539 4.11147 3.57879 3.9768 3.67532 3.87301L7.29248 0.215341C7.3886 0.122353 7.59223 0 7.72756 0C7.86288 0 8.07536 0.122353 8.17022 0.215341L11.7697 3.83386C11.866 3.93412 11.9195 4.0659 11.9195 4.20275C11.9195 4.3396 11.866 4.47138 11.7697 4.57165C11.7221 4.61759 11.6657 4.654 11.6036 4.67881C11.5415 4.70362 11.4749 4.71633 11.4077 4.71622C11.3405 4.7161 11.274 4.70317 11.212 4.67815C11.1499 4.65313 11.0936 4.61652 11.0462 4.57042L8.35487 1.9365V10.705C8.35487 10.9778 8.03742 11.1993 7.75412 11.1993C7.47208 11.1993 7.09012 10.979 7.09012 10.705V2.00135Z"
        fill={color}
      />
      <path
        d="M11.6888 7.6106H14.25C14.5261 7.6106 14.75 7.83445 14.75 8.1106V16.9065C14.75 17.1827 14.5261 17.4065 14.25 17.4065H1.25C0.973857 17.4065 0.75 17.1827 0.75 16.9065V8.1106C0.75 7.83445 0.973858 7.6106 1.25 7.6106H3.60714"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
